import useAPIClient from '@src/shared/hooks/api/useAPIClient';
import { useQuery } from '@tanstack/react-query';

import { clientContactRowFromDto } from '../../lib';
import type {
  ClientContactPeriod,
  ClientContactRow,
  ClientContactRowDto,
} from '../../types';
import { clientUrl } from './constants';
import { clientDetailKey } from './keys';

/**
 * Positions at a client: the current ones (Contacts section) or the former
 * ones (Former Contacts). Keyed below the client page, so creating a
 * contact or saving a contact reloads them.
 */
export function useClientContactRows(
  clientId: number | string,
  { period = 'current' }: { period?: ClientContactPeriod } = {},
) {
  const apiClient = useAPIClient();
  return useQuery({
    queryKey: [...clientDetailKey(clientId), 'contacts', period],
    queryFn: ({ signal }) =>
      apiClient.request({
        url: `${clientUrl(clientId)}contacts/`,
        payload: period === 'former' ? { period } : {},
        options: { signal },
      }) as Promise<ClientContactRowDto[]>,
    select: (data): ClientContactRow[] => data.map(clientContactRowFromDto),
  });
}
